import { render, staticRenderFns } from "./Petitioner.vue?vue&type=template&id=c7ccb83e"
import script from "./Petitioner.vue?vue&type=script&lang=js"
export * from "./Petitioner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports